export default __webpack_public_path__ + "img/all-that-is-needed.webp";